<app-create-update-default (entityLoaded)="entityLoaded($event)"
                           (entitySaved)="entitySaved($event)"
                           [buildPayload]="buildPayload"
                           [formGroup]="formGroup"
                           [id]="id"
                           [inDialog]="inDialog"
                           [returnUrl]="returnUrl"
                           [hideSaveButton]="hideSaveButton"
                           [findOneService]="findByIdServe"
                           [service]="service"
                            #createUpdateDefaultComponent>
    <ng-template template-content>
        <app-card title="Informations générales">
            <div class="row">
                <app-form-field [required]="true" label="Actif">
                    <app-checkbox-input [parentFormGroup]="formGroup" parentFormControlName="active"></app-checkbox-input>
                </app-form-field>
                <app-form-field [required]="true" label="Catégorie" *ngIf="!hideCategoryInput">
                    <app-lov-value-select-filter
                            [newItemModalOptions]="lovValueModalOptions"
                            [parentFormGroup]="formGroup"
                            lovListName="PRODUCT_CATEGORY"
                            parentFormControlName="categoryValue"></app-lov-value-select-filter>
                </app-form-field>
                <app-form-field [required]="true" label="Type" *ngIf="!hideTypeValueInput">
                    <app-lov-value-select-filter
                            [parentFormGroup]="formGroup"
                            lovListName="PRODUCT_TYPE"
                            parentFormControlName="typeValue"></app-lov-value-select-filter>
                </app-form-field>
                <app-form-field [required]="true" label="Libellé">
                    <app-input-text [parentFormGroup]="formGroup" parentFormControlName="label"></app-input-text>
                </app-form-field>
                <app-form-field [label]="codeLabel">
                    <app-input-text [parentFormGroup]="formGroup" parentFormControlName="code"></app-input-text>
                </app-form-field>
                <app-form-field label="Couleur">
                    <app-lov-value-select-filter [parentFormGroup]="formGroup" parentFormControlName="colorValue" lovListName="INSOLE_COLOR"></app-lov-value-select-filter>
                </app-form-field>
            </div>
        </app-card>
        <app-card title="Facture">
            <div class="row">
                <app-form-field label="Libellé sur la facture">
                    <app-input-text [parentFormGroup]="formGroup" parentFormControlName="invoiceLabel"></app-input-text>
                </app-form-field>
                <app-form-field label="Description" [size]="12">
                    <app-input-text [parentFormGroup]="formGroup" parentFormControlName="description"></app-input-text>
                </app-form-field>
            </div>
        </app-card>
        <app-card title="Prix">
            <div class="row" *ngIf="!hideVatInputs">
                <app-form-field label="TVA">
                    <app-number-input [maxValue]="100" [parentFormGroup]="formGroup" [decimalDigits]="2"
                                      parentFormControlName="taxPercentage" unit="%"></app-number-input>
                </app-form-field>
            </div>
            <div class="row">
                <app-form-field label="Prix HTVA" *ngIf="!hideVatInputs">
                    <app-amount-input [parentFormGroup]="formGroup" parentFormControlName="priceVatExcluded"
                                      unit="€"></app-amount-input>
                </app-form-field>
                <app-form-field [label]="priceVatIncludedLabel ? priceVatIncludedLabel : (!hideVatInputs ? 'Prix TTC' : 'Prix')">
                    <app-amount-input [parentFormGroup]="formGroup" parentFormControlName="priceVatIncluded"
                                      unit="€"></app-amount-input>
                </app-form-field>
            </div>
            <div class="row" *ngIf="!hideAdvancedInput">
                <app-form-field label="Acompte HTVA" *ngIf="!hideVatInputs">
                    <app-amount-input [parentFormGroup]="formGroup" parentFormControlName="advanceVatExcluded"
                                      unit="€"></app-amount-input>
                </app-form-field>
                <app-form-field [label]="!hideVatInputs ? 'Acompte TTC' : 'Acompte'">
                    <app-amount-input [parentFormGroup]="formGroup" parentFormControlName="advanceVatIncluded"
                                      unit="€"></app-amount-input>
                </app-form-field>
            </div>
        </app-card>
        <app-card *ngIf="!hideStock">
            <div class="row">
                <app-form-field label="Gérer le stock">
                    <app-checkbox-input [parentFormGroup]="formGroup"
                                        parentFormControlName="hasStock"></app-checkbox-input>
                </app-form-field>
                <app-number-input *ngIf="hasStock" [parentFormGroup]="formGroup" [decimalDigits]="0"
                                  parentFormControlName="stock"></app-number-input>
            </div>
        </app-card>
        <app-card title="Commentaire">
            <app-form-field size="12">
                <app-rich-text-editor [parentFormGroup]="formGroup"
                                      parentFormControlName="comment"></app-rich-text-editor>
            </app-form-field>
        </app-card>
    </ng-template>
</app-create-update-default>
